import { AccordionItem, AccordionPanel } from '@chakra-ui/react';
import ParameterField from 'components/productManager/ParameterField';
import { Accordion, AccordionButton } from 'components/UI';
import { IParameter } from '../../../server/types';

interface ProductParameterItemProps {
  parameters: string[];
  params: IParameter[];
}

const ProductParameterItem = ({ parameters, params }: ProductParameterItemProps) => {
  if (!Array.isArray(parameters)) return null;

  const getFieldType = (key: string) => {
    switch (key) {
      case 'values':
        return 'values';
      case 'valueConditions':
      case 'onConditions':
        return 'expressions';
      default:
        return 'parameter';
    }
  };

  const getFieldDisplayName = (key: string) => {
    switch (key) {
      case 'name':
        return 'Parameter Name';
      case 'conditional':
        return 'Always On';
      default:
        return key;
    }
  };

  const renderParameterFields = (data: IParameter) =>
    Object.entries(data).map(([key, value]) => {
      if (key === 'key' || key === '_id') return null;

      const parameterData = key === 'valueConditions' || key === 'onConditions' ? value.expressions : value;
      const fieldType = getFieldType(key);
      const displayName = getFieldDisplayName(key);

      return <ParameterField key={key} displayName={displayName} data={parameterData} fieldType={fieldType} />;
    });

  const renderParameters = parameters.map((key: string) => {
    const parameterData = params[+key] ?? {};

    return (
      <AccordionItem key={key} bg="base2Colour.500" border="none">
        <AccordionButton
          sx={{
            mx: 2.5,
            px: 0,
            w: 'calc(100% - 1.25rem)',
            fontSize: 'sm',
            textTransform: 'uppercase',
            borderBottom: '2px solid',
            borderColor: 'base2Colour.400',
          }}
        >
          {parameterData.name}
        </AccordionButton>

        <AccordionPanel p={0} bg="base2Colour.500">
          <ParameterField displayName="Key" data={key.toString()} fieldType="text" />
          {renderParameterFields(parameterData)}
        </AccordionPanel>
      </AccordionItem>
    );
  });

  return <Accordion allowMultiple>{renderParameters}</Accordion>;
};
export default ProductParameterItem;
